export function validateSearch(query) {
  if (!query || query === "" || query.length >= 4) {
    return undefined
  }
  return i18n.t("invalid_tariff_search", "Bitte mind. 4 Zeichen angeben")
}
